/**
 * Mappers for position detail operations
 */

import type {
  LC_GetPositionByIdOut,
  PositionDetail,
} from '../types';


export function mapPositionDetailFromTransport(
  transport: LC_GetPositionByIdOut,
): PositionDetail {
  return {
    id: transport.positionId,
    code: transport.positionCode,
    name: transport.positionName,
    description: transport.description,
    areaId: transport.areaId,
    areaName: transport.areaName,
    isEnabled: transport.isEnabled,
    createdDate: transport.createdDate,
    createdBy: transport.createdBy,
    modifiedDate: transport.modifiedDate || undefined,
    modifiedBy: transport.modifiedBy || undefined,
  };
}